/* BT Events — pre-launch micro-conversions → GA4 (added 2026-09-09).
   Why this file exists: the July "BT Events" custom pixel can never reach the page's gtag()
   (Shopify custom pixels run in a sandboxed iframe), so none of the six intent events ever
   fired. This runs in the theme itself, where the Google & YouTube channel's gtag() lives.
   Additive; remove the one script tag in snippets/meta-tags.liquid to revert. */
(function () {
  'use strict';
  if (window.__btEventsLoaded) return;
  window.__btEventsLoaded = true;

  var queue = [];
  function send(name, params) {
    var p = params || {};
    p.page_path = location.pathname;
    if (typeof window.gtag === 'function') { window.gtag('event', name, p); return; }
    queue.push([name, p]);
  }
  // gtag is loaded async by the Google channel app; flush anything queued before it arrived.
  var tries = 0, flush = setInterval(function () {
    if (typeof window.gtag === 'function') {
      queue.forEach(function (q) { window.gtag('event', q[0], q[1]); });
      queue = []; clearInterval(flush);
    } else if (++tries > 50) { clearInterval(flush); }
  }, 200);

  // 1, 3, 4 — CTA clicks by destination (delegated, so it survives section re-renders)
  var CTA = [
    [/\/pages\/founding-50|\/products\/founding-50-first-batch/, 'founding50_cta_click'],
    [/\/pages\/ranch-partners/, 'ranch_partner_cta'],
    [/\/pages\/office-delivery|\/products\/office-snack-delivery-austin/, 'office_interest'],
    [/\/pages\/wholesale|\/pages\/events/, 'trade_interest']
  ];
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/^mailto:/i.test(href)) { send('email_click', { link_text: (a.textContent || '').trim().slice(0, 80) }); return; }
    for (var i = 0; i < CTA.length; i++) {
      if (CTA[i][0].test(href)) {
        send(CTA[i][1], { link_text: (a.textContent || '').trim().slice(0, 80), link_url: href });
        return;
      }
    }
  }, true);

  // 2 — email capture (Dawn newsletter + contact forms post to /contact)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var id = (f.id || '') + ' ' + (f.getAttribute('action') || '') + ' ' + (f.className || '');
    if (/newsletter|customer\[email\]|contact/i.test(id) || f.querySelector('input[name="contact[email]"]')) {
      send('email_signup', { form: f.id || f.getAttribute('action') || 'form' });
    }
  }, true);

  // 5 — coming-soon product views (the two SKUs with no inventory yet)
  if (/^\/products\/(beef-biltong-the-classic|spicy-beef-biltong-hill-country-heat)/.test(location.pathname)) {
    send('product_view_comingsoon', { product: location.pathname.split('/').pop() });
  }

  // 6 — 75% read on any blog article, once per pageview
  if (/^\/blogs\//.test(location.pathname)) {
    var fired = false;
    function onScroll() {
      if (fired) return;
      var h = document.documentElement, max = (h.scrollHeight - h.clientHeight) || 1;
      if ((window.scrollY || h.scrollTop) / max >= 0.75) {
        fired = true; window.removeEventListener('scroll', onScroll);
        send('article_read_75', { article: location.pathname.split('/').pop() });
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
